import {BrowserRouter, Routes, Route, useLocation} from 'react-router-dom'
import React, {useEffect, useState} from 'react'
import dayjs from 'dayjs'
import {OrderDetailsComponent} from './screens/order-details'
// import {Home} from './screens/home'
import {PaymentDetailsComponent} from './screens/payment-details'
import {AppointmentDetailsComponent} from './screens/appointment-details'
import {AcknowledgementComponent} from './screens/acknowledgement'
import AuthForm from './components/AuthForm'
import {BlueGradientBackground} from './components/AuthForm'
import NotFoundForm from './components/NotFoundForm'
import VerifyToken from './components/VerifyToken'
import {client} from './utils/api-client'
import {Spinner} from './components/custom/loader-spinner'
import {useDispatch} from 'react-redux'
import {mobileViewStatus} from './redux/screenViewSlice'
import {PaymentInformationProvider} from './components/keap-partner/payment-information-components/contexts/payment-information-provider'
import CheckStatus from './screens/check-status'

export const PageRouter = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    const checkIfMobile = () => {
      dispatch(mobileViewStatus(window.innerWidth <= 768))
    }
    checkIfMobile()
    window.addEventListener('resize', checkIfMobile)
    sessionStorage.removeItem('accountDetail')

    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/client-order" element={<OrderDetailsComponent />} />
        <Route
          path="/client-appointment"
          element={<AppointmentDetailsComponent />}
        />
        <Route
          path="/client-payment"
          element={
            <PaymentInformationProvider>
              <PaymentDetailsComponent />
            </PaymentInformationProvider>
          }
        />
        <Route path="/" element={<RequireValidLink element={<AuthForm />} />} />
        <Route
          path="/verifytoken"
          element={<RequireValidLink element={<VerifyToken />} />}
        />
        <Route path="/not-found" element={<NotFoundForm />} />
        <Route
          path="/client-acknowledgement"
          element={<AcknowledgementComponent />}
        />
        <Route path="/check-status" element={<CheckStatus />} />
        <Route path="*" element={<NotFoundForm />} />
      </Routes>
    </BrowserRouter>
  )
}

function RequireValidLink({element}) {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const id = params.get('LinkId')
  const [isLoading, setIsLoading] = useState(true)
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    let mounted = true
    async function validate() {
      try {
        if (!id) {
          if (mounted) {
            setIsValid(false)
            setIsLoading(false)
          }
          return
        }
        const res = await client(`keappartner/fetchKeapPartnerLinkStatus/${id}`)
        // condition added inorder to bypass condition for 1:Many flow as 1:many will not have entry in keap client map table
        if (res?.data.length === 0) {
          setIsValid(true)
          setIsLoading(false)
          return
        }
        if (mounted) {
          const items = res && Array.isArray(res.data) ? res.data : []
          // check if no data found then its 1:Many flow

          const hasValidPending = (items || []).find(item => {
            if (!item || item.link_status !== 'Pending') return false

            const expiry =
              item.link_expiry_datetime ||
              res.link_expiry_datetime ||
              item.linkExpiryDatetime ||
              item.expiry

            if (!expiry) return true

            const parsed = dayjs(expiry)
            if (!parsed.isValid()) return true

            return !parsed.isBefore(dayjs())
          })

          setIsValid(!!hasValidPending)
          setIsLoading(false)
        }
      } catch (err) {
        if (mounted) {
          setIsValid(false)
          setIsLoading(false)
        }
      }
    }

    validate()
    return () => {
      mounted = false
    }
  }, [id])

  const msg =
    'Uh-oh! It looks like this link has expired. Please reach out to your Business Consultant for a new one.'

  if (!isValid && !isLoading) return <NotFoundForm message={msg} />
  if (isLoading)
    return (
      <>
        <BlueGradientBackground />
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 9999,
          }}
        >
          <Spinner />
        </div>
      </>
    )

  return element
}
